import React, { useEffect } from "react"
import styled from "styled-components"

import InvestorsNavbar from "../../components/investors-navbar"
import SEO from "../../components/seo"

import { H2, Sectionheader } from "../../components/common"

export const PageContainer = styled.div`
  /* mobile first */

  /* tablet */
  @media screen and (min-width: 640px) {
    margin: 0 auto;
    padding-top: 50px;
    max-width: 614px;
  }

  /* desktop */
  @media screen and (min-width: 980px) {
    padding-top: 135px;
    max-width: 1170px;
    margin: 0 auto;
  }
`

const SidePaddingWrapper = styled.div`
  @media screen and (max-width: 640px) {
    padding: 0 20px;
  }
`

const Table = styled.table`
  /* mobile first */

  thead {
    font-weight: bold;
  }

  th,
  td {
    border-bottom: 1px solid #afafaf;
    border-left: none;
    border-right: none;
    padding: 20px;
  }

  width: 100%;
  border-top: 1px solid #afafaf;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  font-size: 15px;

  /* tablet */
  @media screen and (min-width: 640px) {
    font-size: 20px;
  }
`

const TableWrapper = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  white-space: nowrap;
`
const InformativeBlock = styled.div`
  align-self: start;
  font-size: 17px;
  margin-bottom: 20px;

  h3 {
    margin-bottom: 10px;
  }
`

const SubTitle = styled.h2`
  margin: 45px 0 35px 0;
`

const CisionIframe = styled.iframe`
  width: 100%;
  border: none;
  height: 500px;
  .tab-content {
    height: 500px;
  }
`

const ResizableIframe = (props) => {
  const iframeReference = React.createRef()

  useEffect(() => {
    console.log("height changed")
    // Create browser compatible event handler.
    const eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent"
    const eventer = window[eventMethod]
    const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message"
    // Listen for a message from the iframe.
    eventer(
      messageEvent,
      (e) => {
        if (e.data.iframeHeight && iframeReference && iframeReference.current) {
          iframeReference.current.style.minHeight = e.data.iframeHeight + "px"
          console.log(e.data)
        }
      },
      false
    )
  }, [iframeReference])

  return <CisionIframe ref={iframeReference} {...props} />
}

export default function SharePage() {
  return (
    <React.Fragment>
      <SEO
        title="Checkin.com Group AB - The share"
        description="General information and historical performance of the Checkin.com Group share, CHECK."
        canonical="/investors/share"
        ogImage="/images/og.jpg"
      />
      <PageContainer>
        <InvestorsNavbar />
        <Sectionheader>
          <H2>The Share</H2>
        </Sectionheader>
        <SidePaddingWrapper>
          <InformativeBlock>
            <h3>Shortname</h3>
            <p>CHECK</p>
          </InformativeBlock>
          <InformativeBlock>
            <h3>ISIN</h3>
            <p>SE0015810502</p>
          </InformativeBlock>
          <InformativeBlock>
            <h3>Certified adviser</h3>
            <p>DNB Carnegie Investment Bank AB (publ)</p>
            <p>tel: +46 (0)8 588 68 570</p>
          </InformativeBlock>
          <SubTitle>Largest owners as of September 30, 2026</SubTitle>
        </SidePaddingWrapper>
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>
                  <span>Owner</span>
                </th>
                <th>
                  <span>Shares</span>
                </th>
                <th>
                  <span>Ownership</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>Johan Qviberg, privately and via companies</span>
                </td>
                <td>
                  <span>8,742,685</span>
                </td>
                <td>
                  <span>26.4%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Christer Fåhraeus, privately and via companies</span>
                </td>
                <td>
                  <span>7,675,204</span>
                </td>
                <td>
                  <span>23.1%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Alexey Kuznetsov, privately and via companies</span>
                </td>
                <td>
                  <span>2,880,759</span>
                </td>
                <td>
                  <span>8.7%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Nicklas Storåkers</span>
                </td>
                <td>
                  <span>2,388,264</span>
                </td>
                <td>
                  <span>7.2%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Markus Terland, privately and via companies</span>
                </td>
                <td>
                  <span>716,927</span>
                </td>
                <td>
                  <span>2.2%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Eirik Winter</span>
                </td>
                <td>
                  <span>672,656</span>
                </td>
                <td>
                  <span>2.0%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Emanuel Stihl</span>
                </td>
                <td>
                  <span>620,000</span>
                </td>
                <td>
                  <span>1.9%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Wilhelm Risberg</span>
                </td>
                <td>
                  <span>394,424</span>
                </td>
                <td>
                  <span>1.2%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Joel Cassel, privately and via companies</span>
                </td>
                <td>
                  <span>320,553</span>
                </td>
                <td>
                  <span>1.0%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Anders Borg</span>
                </td>
                <td>
                  <span>230,608</span>
                </td>
                <td>
                  <span>0.7%</span>
                </td>
              </tr>
            </tbody>
          </Table>
        </TableWrapper>
        {/* <SidePaddingWrapper>
          <SubTitle>Details</SubTitle>
          <ResizableIframe src="/cision-iframe/sharegraph.html" />
        </SidePaddingWrapper> */}
      </PageContainer>
    </React.Fragment>
  )
}
